export enum AppCookies {
    DEMO_MEMBERSHIP_EMAIL = `demo-membership-email`,
    DEMO_MEMBERSHIP_ID = `demo-membership-id`,
    DEMO_EXCHANGE_ID = `demo-exchange-id`,
    CAMPAIGN_CODE = `campaign-code`,
    MEMBERSHIP_ID = `membership-id`,
    RENEWAL_CAMPAIGN_CODE = `renewal-campaign-code`,
    SESSION_HASH = `session-hash`,
    MYNTUC_MEMBERSHIP_ID = `myntuc-membership-id`,
    PLS_LOGIN_TOKEN = `pls-login-token`
}